import { render, staticRenderFns } from "./PlSalesStatisticTable.vue?vue&type=template&id=fb0ce1fc&scoped=true"
import script from "./PlSalesStatisticTable.vue?vue&type=script&lang=js"
export * from "./PlSalesStatisticTable.vue?vue&type=script&lang=js"
import style0 from "./PlSalesStatisticTable.vue?vue&type=style&index=0&id=fb0ce1fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0ce1fc",
  null
  
)

export default component.exports